import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {NabilAuctionCategoryModel, SortNabilAuctionCategoryModel} from '../Model/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const NABIL_AUCTION_CATEGORY_API = `${API_URL}/nabil-auction-category`

export const service = {
  getNabilAuctionCategory: (params: ParamsModel) => {
    return axios.get(NABIL_AUCTION_CATEGORY_API, {params})
  },
  getAllNabilAuctionCategory: () => {
    return axios.get(`${NABIL_AUCTION_CATEGORY_API}/list`)
  },

  addNabilAuctionCategory: (data: any) => {
    return axios.post(NABIL_AUCTION_CATEGORY_API, data)
  },

  updateNabilAuctionCategory: (body: NabilAuctionCategoryModel, id: string) => {
    return axios.put(`${NABIL_AUCTION_CATEGORY_API}/${id}`, body)
  },

  deleteNabilAuctionCategory: (data: {ids: string[]}) => {
    return axios.delete(`${NABIL_AUCTION_CATEGORY_API}/bulk-delete`, {data})
  },

  enableNabilAuctionCategory: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_CATEGORY_API}/enable`, {ids: data})
  },

  disableNabilAuctionCategory: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_CATEGORY_API}/disable`, {ids: data})
  },

  singleEnableNabilAuctionCategory: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_CATEGORY_API}/enable`, {ids: [data]})
  },

  singleDisableNabilAuctionCategory: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_CATEGORY_API}/disable`, {ids: [data]})
  },
  sortNabilAuctionCategory: (body: SortNabilAuctionCategoryModel) => {
    return axios.patch(`${NABIL_AUCTION_CATEGORY_API}/sort`, body)
  },
}
